import { useEffect, useState } from 'react'

const SplashScreen = () => {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    // Auto-dismiss after 1.5 seconds (reduced from 3s)
    const timer = setTimeout(() => {
      setVisible(false)
    }, 1500)

    // Expose global function for manual dismissal (called by React after mount)
    ;(window as unknown as { __dismissSplash?: () => void }).__dismissSplash = () => {
      setVisible(false)
      clearTimeout(timer)
    }

    return () => {
      clearTimeout(timer)
      delete (window as unknown as { __dismissSplash?: () => void }).__dismissSplash
    }
  }, [])

  if (!visible) return null

  return (
    <div
      id="noe-splash"
      className="fixed inset-0 z-[99999] flex items-center justify-center overflow-hidden bg-noe-950"
    >
      <div className="relative flex flex-col items-center gap-4">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <div className="w-4 h-4 rounded-full bg-noe-brand animate-pulse" />
          <div className="text-2xl font-bold tracking-wide text-noe-100">NOÉ CONNECT</div>
        </div>
        
        {/* Loading indicator */}
        <div className="w-24 h-1 bg-noe-800 rounded-full overflow-hidden">
          <div className="h-full w-1/3 rounded-full animate-shimmer bg-noe-brand" />
        </div>
        
        {/* Subtle text */}
        <div className="text-sm text-noe-500">
          Conectando comunidade...
        </div>
      </div>
    </div>
  )
}

export default SplashScreen